var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIq(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#FF4B55"
    },
    width: 512,
    height: 170.81
  }), /*#__PURE__*/React.createElement("rect", {
    y: 341.63,
    style: {
      fill: "#464655"
    },
    width: 512,
    height: 170.37
  }), /*#__PURE__*/React.createElement("rect", {
    y: 170.81,
    style: {
      fill: "#F5F5F5"
    },
    width: 512,
    height: 170.81
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M308.065,233.525c-0.928-0.484-2.027-2.211-1.684-2.967c0.361-0.794-0.2-0.725,1.696-0.161   c3.43,0.888,5.649,0.483,7.829-1.372l1.936-1.533l2.26,1.13c1.25,0.564,2.541,0.967,2.905,0.886   c1.05-0.242,3.068-2.825,3.027-3.713c-0.041-1.209,0.847-0.886,1.291,0.405c0.928,2.422-0.779,6.599-3.12,7.163   c-1.128,0.322-2.178,0.242-3.955-0.322c-2.097-0.808-2.422-0.808-3.55,0C314.361,234.897,311.012,235.06,308.065,233.525"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M316.9,224.182c-1.132-1.587-2.492-7.141-2.095-8.499c0.395-1.248,0.792-1.474,1.869-1.135   c1.927,0.679,2.382,1.927,2.153,6.462C318.487,224.408,318.035,225.543,316.9,224.182"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M241.005,248.73c-4.651,2.646-11.568,3.101-11.568,10.434c-10.13,0.377-22.075,0.831-32.85,0.604   c2.92-3.771,21.401-20.853,29.086-27.623c1.272-1.12,1.704-3.289,0.964-4.814l-0.199-0.41c-1.108-2.285-4.122-2.829-5.957-1.074   c-7.658,7.325-15.247,14.152-16.483,15.323c-9.915,10.02-12.822,12.94-14.38,14.508c-1.109,1.116-1.726,2.627-1.718,4.2   l0.001,0.102c0.017,3.269,2.672,5.911,5.942,5.911h43.381c2.458,0-0.565-8.543,2.609-8.543c2.207,0,2.41,3.066,2.313,6.312   c-0.074,2.47-2.108,4.423-4.579,4.427c-18.755,0.026-38.279,0.205-56.651,0.222c-1.518,0.001-2.736-1.23-2.736-2.747v-3.304   c0-2.802-3.112-4.432-5.454-2.893c-0.086,0.056-0.17,0.11-0.254,0.163c-1.223,0.764-1.85,2.263-1.372,3.624   c0.31,0.883,0.444,1.96,0.475,3.085c0.04,1.488-1.171,2.713-2.658,2.759c-6.076,0.186-12.679,0.24-14.555-3.342   c-1.058-2.02-3.309-2.974-5.349-1.955l-0.272,0.136c-2.148,1.074-3.009,3.731-1.831,5.824c2.238,3.979,4.28,8.594,3.22,15.06   c-0.864,2.038-2.492,3.313-4.256,4.462c-1.959,1.276-0.73,4.261,1.569,3.836c5.574-1.03,9.414-5.443,10.589-10.642h86.42   c3.17,0,5.739-2.569,5.739-5.739V257.88C249.397,252.284,243.386,252.51,241.005,248.73z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M350.62,223.947c1.274,0.82,2.553,1.641,3.974,2.32c1.556,0.743,2.15,2.642,1.241,4.107   c-0.241,0.388-0.441,0.82-0.556,1.346v37.197c2.542,0.528,4.001,0.028,5.16-0.771c1.307-0.901,3.077-0.246,3.489,1.288   c0.877,3.263,2.313,6.45,3.079,9.352c0.479,1.813-0.883,3.588-2.759,3.588h-14.572c-1.29,0-2.336-1.046-2.336-2.336v-54.299   C347.34,224.055,349.203,223.036,350.62,223.947z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M332.976,233.005c0.011,10.271,0.131,21.336,0.148,32.346c0.002,1.426-1.155,2.583-2.582,2.583   h-0.167c-1.425,0-2.58-1.155-2.58-2.58v-26.09c0-1.42-1.669-2.18-2.737-1.244l-3.42,2.955c-0.699,0.604-1.102,1.473-1.104,2.397   c-0.012,4.244-0.048,16.6-0.064,21.994c-0.004,1.422-1.158,2.569-2.58,2.569h-0.234c-1.418,0-2.57-1.139-2.58-2.557   c-0.025-3.591-0.07-10.246-0.088-15.237c-0.005-1.436-1.704-2.186-2.784-1.24c-3.543,3.105-4.361,3.807-6.22,5.728   c0.151,0.983,0.908,0,1.361,0.755v4.991c-12.908-2.43-13.872,7.881-13.388,18.946c0.073,1.662,1.438,2.979,3.102,2.979h40.526   c1.503,0,2.721-1.218,2.721-2.721v-50.381c0-1.683-1.997-2.547-3.238-1.411c-0.99,0.906-2.047,1.813-2.955,2.634   C333.382,231.083,332.974,232.017,332.976,233.005z M303.15,267.556c-0.794-2.268,3.668-3.101,4.196-1.059   C307.536,268.992,304.133,269.068,303.15,267.556z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M169.296,286.38c1.55,0,2.797,1.285,2.797,2.797c0,1.589-1.246,2.799-2.797,2.799   c-1.587,0-2.874-1.21-2.874-2.799C166.422,287.666,167.709,286.38,169.296,286.38"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M261.44,225.087c0.757,0.455,1.535,0.89,2.364,1.281c1.496,0.707,2.086,2.566,1.171,3.945   c-0.275,0.415-0.51,0.886-0.648,1.482v37.121c2.694,0.599,4.167,0.012,5.341-0.857c1.17-0.865,2.853-0.267,3.228,1.138   c0.673,2.52,1.685,5.012,2.466,7.378c0.956,2.893-1.19,5.874-4.237,5.874H259.76c-1.841,0-3.333-1.492-3.333-3.333v-51.153   C256.427,225.39,259.234,223.761,261.44,225.087z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", null)), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIq);
export default __webpack_public_path__ + "static/media/iq.c66c6df1f190c5175b27949eb48f1471.svg";
export { ForwardRef as ReactComponent };